import React from 'react';
import './ProductCardSkeleton.css';

/**
 * Componente de esqueleto para exibir durante o carregamento dos produtos
 * Evita o efeito de "piscar" na tela quando os produtos são carregados
 */
const ProductCardSkeleton = () => {
  return (
    <div className="product-card skeleton">
      <div className="product-image-container skeleton-image"></div>
      <div className="product-info">
        <div className="skeleton-name"></div>
        <div className="skeleton-category"></div>
        <div className="skeleton-price"></div>
        <div className="skeleton-stock"></div>
        <div className="skeleton-button"></div>
      </div>
    </div>
  );
};

export default ProductCardSkeleton;
